<template>
  <div>
    <b-col lg="12">
      <b-container>
        <div class="horizontal-card row ">
          <b-col class="p-0 rounded" lg="4">
            <div class="image-box">
              <m-img :src="img" alt="img" class="img-cov"/>
            </div>
          </b-col>
          <b-col lg="8" class="p-3 text-center">
            <slot name="p-1" />
          </b-col>
        </div>
      </b-container>
    </b-col>
  </div>
</template>

<script>
export default {
    name:"S24",
    props:{
        img:{
            default:""
        }
    }
};
</script>

<style scoped>
.horizontal-card{
  background-color: var(--primary);
  border-radius: 20px;
}
.image-box {
  position: relative;
  margin: auto;
  overflow: hidden;
  width:100%;
  text-align: center;
  color: white;
}
.image-box img {
  max-width: 100%;
  transition: all 0.3s;
  display: block;
  width: 100%;
  height: 100%;
  transform: scale(1);
  object-fit: cover;
  border-radius: 0 20px 20px 0;
}

.image-box:hover img {
  transform: scale(1.1);
  filter: blur(0.2rem);
  border-radius: 0 20px 20px 0;
}
</style>